module.exports = __webpack_public_path__ + "img/horizontal_7_3_7016.a79eb09c.png";